import { useEffect } from 'react';
import { useDisplayedCurrencyCode as useDisplayedCurrencyCodeV2, useLockedCurrencyCode as useLockedCurrencyCodeV2, useCurrencyCodeUnitToDisplay as useCurrencyCodeUnitToDisplayV2, useAvailableCurrencyCodes as useAvailableCurrencyCodesV2, useCountryCode as useCountryCodeV2, useCurrencies as useCurrenciesV2 } from '../v2/hooks/pricing/useCurrencyDetails';
import { useSetOneGlobalLoadingState } from '../context/GlobalLoadingStateContext';

/**
 * @deprecated This file provides V1 compatibility wrappers.
 * New code should import directly from V2:
 * `import { useDisplayedCurrencyCode, useCurrencies, ... } from '../v2/hooks/pricing/useCurrencyDetails'`
 */

// Re-export all utility hooks from V2 as the canonical source
export { useDisplayedCurrencyCodeV2 as useDisplayedCurrencyCode, useLockedCurrencyCodeV2 as useLockedCurrencyCode, useCurrencyCodeUnitToDisplayV2 as useCurrencyCodeUnitToDisplay, useAvailableCurrencyCodesV2 as useAvailableCurrencyCodes, useCountryCodeV2 as useCountryCode };

/**
 * V1 wrapper that adds GlobalLoadingStateContext signaling to V2's useCurrencies.
 * Used internally by useInAppCurrencies, usePublicCurrencies, and usePricingPageCurrencies.
 */
const useCurrenciesWithLoadingState = () => {
  const loadingCompletedCallback = useSetOneGlobalLoadingState('Currencies');
  const {
    currencyData,
    error,
    loading
  } = useCurrenciesV2();

  // Signal completion on both success and error to match V1 behavior
  useEffect(() => {
    if (!loading) {
      loadingCompletedCallback();
    }
  }, [loading, loadingCompletedCallback]);
  return {
    currencyData,
    error,
    loading
  };
};

/**
 * V1 compatibility hook for pages that need GlobalLoadingStateContext.
 * @deprecated Use useCurrencies from V2 directly for new code
 * `import { useCurrencies } from '../v2/hooks/pricing/useCurrencyDetails'`
 */
export const usePricingPageCurrencies = ({
  isAppAuth: __isAppAuth
}) => {
  // isAppAuth parameter kept for V1 API compatibility
  // V2's useCurrencies determines auth status automatically via useIsInAppAuth()
  return useCurrenciesWithLoadingState();
};